import { CatListItem } from '@blocks-react/components/ListItem';
import { FC } from 'react';
import cx from 'classnames';
import { Conditional, TextHighlight } from '../../../common';
import styles from './HeaderSearchBarSuggestion.module.scss';
import { HeaderSearchBarSuggestionProps } from './types';

export const HeaderSearchBarSuggestion: FC<HeaderSearchBarSuggestionProps> = ({
  items,
  label,
  highlightText = '',
  onItemClick,
  imgComp: Image = 'img',
}) => (
  <Conditional test={items.length > 0}>
    <CatListItem isStatic>
      <p
        className={cx(
          styles['header__search-bar-suggestion-label'],
          'text-capitalize my-auto'
        )}
      >
        {label}
      </p>
    </CatListItem>
    {items.map(({ displayName, name, value, imageURL }) => {
      const itemName = name ?? displayName
      return (
      <CatListItem
        href={value}
        data-testid={itemName}
        key={`${itemName}${value}`}
        value={itemName}
        onClick={() => onItemClick(itemName)}
      >
        <Conditional test={!!imageURL}>
          <Image
            slot="before"
            loading="lazy"
            height={48}
            width={48}
            className={styles['header__search-bar-suggestion-image']}
            alt={itemName}
            src={`${imageURL}&wid=48&hei=48&fmt=png-alpha`}
          />
        </Conditional>
        <TextHighlight
          text={itemName}
          textToHighlight={highlightText}
        />
      </CatListItem>
    )})}
  </Conditional>
);
